import { gql } from 'graphql-request';

export default gql`
  fragment ChecklistImage on ImageObjectType {
    title
    xl: rendition(fill: "960x500-c100") {
      url
    }
  }
`;
